<div class="flex flex-row w-full justify-between group-text-hover cursor-pointer">
    <div class="flex w-2/3 pl-6">
        <app-field-intervention-status
            [size]="1.5"
            [status]="entity()!.status!" />
        <p class="status-text text-hover">{{ getEntityStatus() }}</p>
    </div>

    <div class="flex w-1/3 justify-evenly items-end">
        <div class="flex w-1/2 justify-end pr-2">
            <p class="text-hover text-right min-w-[8ch]">{{ entity().count }}</p>
        </div>
        <div class="flex w-1/2 justify-end pr-6">
            <p class="text-hover text-right min-w-[4ch]">{{ entity().percentage }}%</p>
        </div>
    </div>
</div>
